export const workIntro = 'We work on hard problems and love going from 0 to 1: building what doesn’t exist yet for startups and established companies.';
export const workHeading = 'When Should You Bring Us In?';
export type EngagementFact = {
  label: string;
  value: string;
};
export type Scenario = {
  id: string;
  title: string;
  description: string;
  capabilities: string[];
  toggleLabel: string;
  facts: EngagementFact[];
  caseStudy: string;
};
export const scenarios: Scenario[] = [{
  id: 'new-revenue',
  title: 'To Create New Lines Of Revenue',
  description: 'An existing business has a new idea but no clear path to market. We find the real customer, collaborate on product design with growth built in, architect the systems and targets tied to revenue goals.',
  capabilities: ['Go-to-Market', 'Pricing Strategy', 'Revenue Operations'],
  toggleLabel: 'Explore our Go-To-Market + RevOps work for a multinational financial services firm.',
  facts: [{
    label: 'Reported to',
    value: 'Founder / CEO'
  }, {
    label: 'Engagement',
    value: '3+ years, ongoing (started as a three-month project).'
  }, {
    label: 'Collaborated With',
    value: 'Product, Sales, Finance, and Marketing teams.'
  }, {
    label: 'Role',
    value: 'Embedded go-to-market and growth builder / operator.'
  }],
  caseStudy: 'A multinational financial services firm had a valuable training capability but no clear path to commercialize it. We launched that capability as a hands-on training program for professionals, with its own revenue model and a funnel built to win customers without paid marketing. From an MVP, the program’s revenue doubled in year two and it is now a significant driver of the firm’s business.'
}, {
  id: 'proving-models',
  title: 'To Prove Models On A Deadline',
  description: 'A company has funding and a short window to show real traction. We build systems that find out what customers will pay for: low-cost experiments, with a clear read on what drives paid conversion and retention so budget goes behind what’s working.',
  capabilities: ['Business Operations', 'Unit Economics', 'Decision Frameworks'],
  toggleLabel: 'Explore our BizOps system design for a venture-backed startup.',
  facts: [{
    label: 'Reported to',
    value: 'Founder'
  }, {
    label: 'Engagement',
    value: 'Four-month project extended to a year; ongoing advisor to the founder.'
  }, {
    label: 'Collaborated With',
    value: 'Product, Finance, Engineering, Legal, and Design teams.'
  }, {
    label: 'Role',
    value: 'Founding head of strategy & operations (monetization).'
  }],
  caseStudy: 'A venture-backed startup needed to find out quickly what would make people pay for subscriptions. We built an experimentation and decision-making system from scratch. This gave the team a repeatable way to test ideas, decide which to scale or stop, and put the strongest ones into market. Subscriptions grew about 6x in the six months that followed, while the cost of each experiment fell by more than half.'
}, {
  id: 'stalled-growth',
  title: 'To Find The Real Reason Growth Has Stalled',
  description: "We trace the stall to its cause (wherever it lives) by looking at how the company sells, how teams are organized, and what customers really need. Then we rebuild what’s broken and connect the parts into one operating system.",
  capabilities: ['Organizational Design', 'Positioning', 'Customer Journey Design'],
  toggleLabel: 'Explore our Organizational Design work for a venture advisory network.',
  facts: [{
    label: 'Reported to',
    value: 'Founder / CEO'
  }, {
    label: 'Engagement',
    value: 'Initially a three-month sprint; ongoing advisor to the founder and leadership team.'
  }, {
    label: 'Collaborated With',
    value: 'Leadership team including Managing Director and VC Strategy lead.'
  }, {
    label: 'Role',
    value: 'Org design & operating model advisor.'
  }],
  caseStudy: 'A venture advisory network wasn’t profitable and believed its brand was holding back sales. We found the bigger issue: its team and services weren’t organized around what customers actually needed. We redesigned the organization from the buyer inward by consolidating a confusing customer journey into 3 clear paths. Then we rebuilt internal roles, team structure, and operating systems around each path. Sales cycles fell from months to under two weeks, and the network is on track to profitability.'
}];